import { render, staticRenderFns } from "./clinical_trial.vue?vue&type=template&id=6fbafd1b&scoped=true"
import script from "./clinical_trial.vue?vue&type=script&lang=js"
export * from "./clinical_trial.vue?vue&type=script&lang=js"
import style0 from "./clinical_trial.vue?vue&type=style&index=0&id=6fbafd1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbafd1b",
  null
  
)

export default component.exports